module.exports = __webpack_public_path__ + "static/media/ZALAND.cd97ad0f.svg";